var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86887 20.9464C9.86887 21.5283 10.6028 22 11.5082 22C12.4136 22 13.1475 21.5283 13.1475 20.9464H9.86887Z",
    fill: "#FFCD9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7213 14.8569H11.5082H4.29508C4.29508 14.8569 2.9836 16.1684 2.9836 17.4799C2.9836 17.4799 7.57375 14.8569 8.55738 19.1192C8.75672 19.9831 8.88523 22.07 11.5082 21.0864C14.1312 22.07 14.2597 19.9831 14.459 19.1192C15.4426 14.8569 20.0328 17.4799 20.0328 17.4799C20.0328 16.1684 18.7213 14.8569 18.7213 14.8569Z",
    fill: "#FFDEB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1721 8.22949C13.1721 8.22949 18.0902 2 19.7295 2C20.7131 2 19.0738 9.86886 18.0902 12.4918L13.1721 8.22949Z",
    fill: "#FF8C46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7295 2C16.4508 4.29508 15.1393 9.86886 15.1393 9.86886L15.0265 9.8366L13.1721 8.22953C13.1721 8.22949 18.0901 2 19.7295 2Z",
    fill: "#FFA54B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5164 8.22949C9.5164 8.22949 4.59835 2 2.95902 2C1.97543 2 3.61476 9.86886 4.59835 12.4918L9.5164 8.22949Z",
    fill: "#FF8C46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.959 2C6.23767 4.29508 7.54915 9.86886 7.54915 9.86886L7.662 9.8366L9.51634 8.22953C9.51638 8.22949 4.59833 2 2.959 2Z",
    fill: "#FFA54B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.082C2 17.082 5.60656 14.7869 8.22949 16.4262C9.61964 17.2951 9.21308 19.6913 11.5082 19.6913C13.8032 19.6913 13.3967 17.2951 14.7868 16.4262C17.4098 14.7869 21.0163 17.082 21.0163 17.082C19.377 11.1803 15.2165 7.24591 11.5082 7.24591C7.79984 7.24591 3.63933 11.1803 2 17.082Z",
    fill: "#FFA54B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88525 15.4426C9.24741 15.4426 9.54099 15.149 9.54099 14.7869C9.54099 14.4247 9.24741 14.1311 8.88525 14.1311C8.52309 14.1311 8.22951 14.4247 8.22951 14.7869C8.22951 15.149 8.52309 15.4426 8.88525 15.4426Z",
    fill: "#464655"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1312 15.4426C14.4933 15.4426 14.7869 15.149 14.7869 14.7869C14.7869 14.4247 14.4933 14.1311 14.1312 14.1311C13.769 14.1311 13.4754 14.4247 13.4754 14.7869C13.4754 15.149 13.769 15.4426 14.1312 15.4426Z",
    fill: "#464655"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6558 19.5068C12.6558 19.9029 12.142 20.5109 11.5082 20.5109C10.8745 20.5109 10.3607 19.9029 10.3607 19.5068C10.3607 19.1107 10.8745 18.7896 11.5082 18.7896C12.142 18.7896 12.6558 19.1107 12.6558 19.5068Z",
    fill: "#464655"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask-icon.9739405e.svg";
export { ForwardRef as ReactComponent };